module.exports = __webpack_public_path__ + "static/media/chrome.fc7f0dfe.png";